var Core = require('f.component.video.pc');

var utils = require('f.component.util.pc');

var imageList = require('../imageList');
var defaultConf = {
    swfUrl: '//y0.ifengimg.com/swf/ifengFreePlayer_v5.0.71.swf',
    // swfUrl: '//img.ifeng.com/swf/ifengVplayer_v5.0.53.swf',
    containerId: '',
    width: 600,
    height: 455
};





var defaultParamConf = {
    'allowFullScreen': 'true',
    'wmode': 'transparent',
    'allowScriptAccess': 'always'
};

var defaultVarConf = {
    'guid': '',
    'from': utils.getFrom(),
    'AutoPlay': true,
    'ADPlay': true,
    'uid': utils.getCookie('userid'),
    'sid': utils.getCookie('sid'),
    'locid': utils.getCookie('ilocid'),
    'startTime': utils.getStarTime(),
    'parent': 0,
    'adType': 1,
    'preAdType': 0,
    'pageurl': window.location.href,
    'PlayerName': 'VZHPlayer'
};



function  formatOptions(videoData) {
    videoData.guid = videoData.video_id;
    var optionsData ={
        conf :utils.containParams(defaultConf,videoData),
        varConf : utils.containParams(defaultVarConf,videoData),
        paramConf :utils.containParams(defaultParamConf,videoData),
        pauseCallback: function () {
            alert('pause');
        },
        autoPlay: true
    };

    return optionsData;
}

var Video = function (options) {
    this.init(options);
};

Video.current =  null;


Video.prototype = {
    init : function (options) {
        this.videoOptions = formatOptions(options);
        this.options = options;
        this.videoOptions.listId = options.mid;
            this.initDom(options);
            this.bindDomEvent();
    },
    initDom : function (options) {
        var imageIcon = imageList(options);
        this.el = $(imageIcon);
    },

    bindDomEvent : function () {
        var _self = this;
        this.el.on("click", '.js_icon-video',function () {
            //先关闭正在播放的视屏
            if (Video.current != null) {
                Video.current.destroy();
                Video.current = null;
                $('.js_p_video').find('.js_inner').show();
                $('.closeVideo').hide();
            }

            var vid = $(this).attr('data-vid');
            var mid = $(this).attr('data-mid');
            var isTop = $(this).attr('data-isTop');
            var from = $(this).attr('data-from');
            var uid = $(this).attr('data-uid');
            var videoContainer = $(this).parent();
            videoContainer.show();
            var vw = _self.options.width;
            var vh = _self.options.videoRatio * vw;
            Video.current = new Core(_self.videoOptions);
            Video.current.renderTo(videoContainer);
            $(this).parents('.js_p_video').find('.closeVideo').show();
            $(this).hide();
        });
        this.el.on('click', '.closeVideo', function () {
            var vid = $(this).attr('data-vid');
            var mid = $(this).attr('data-mid');
            var isTop = $(this).attr('data-isTop');
            var id = isTop + '_' + mid + '_' + vid;
            if (Video.current != null) {
                Video.current.destroy();
                Video.current = null;
            }
            $(this).hide();
            $('#' + id).hide();
            $(this).parents('.js_p_video').find('.js_inner').show();
        })
    },

    renderTo : function (parentNode) {
        $(parentNode).append(this.el);
    },
};

module.exports = Video;



// WEBPACK FOOTER //
// /Users/zhujian/Desktop/code/live_system/live/modules/f.component.videolist.pc/app/modules/lib/index.js